import { useEffect } from 'react';

import {
	useGetJiraConfig,
	useSetWorkflowValidators,
} from '../providers/BulkCreateContextProvider.tsx';
import { useBulkCreateLoggingEvents } from '../utils/useBulkCreateLoggingEvents.tsx';

import { fetchWorkflowValidators } from './apiUtils.ts';

export const FETCH_WORKFLOW_VALIDATORS = 'fetch-workflow-validators';

export const useGetAllWorkflowValidators = () => {
	const { logRequestFailed } = useBulkCreateLoggingEvents();
	const { currentJiraSite, currentJiraProject, currentDefaultIssueType } = useGetJiraConfig();
	const setWorkflowValidators = useSetWorkflowValidators();

	useEffect(() => {
		const cloudId = currentJiraSite?.cloudId;
		const projectId = currentJiraProject?.id;
		const issueTypeId = currentDefaultIssueType?.id;
		if (!cloudId || !projectId || !issueTypeId) {
			return;
		}
		const getValidators = async () => {
			try {
				const data = await fetchWorkflowValidators({
					cloudId,
					projectId,
					issueTypeId,
				});
				void setWorkflowValidators(data ?? null);
			} catch (error: Error | unknown) {
				logRequestFailed({
					requestName: FETCH_WORKFLOW_VALIDATORS,
					errorMessage: (error as Error).message,
				});
			}
		};

		void getValidators();
	}, [
		currentJiraSite,
		currentJiraProject,
		currentDefaultIssueType,
		logRequestFailed,
		setWorkflowValidators,
	]);
};
